import { createContext, useContext, useState, useEffect } from "react";
import { useParams } from "react-router";

import { TiVoTargets } from "hooks/tivoApps";

const TargetsContext = createContext<{
  targets: TiVoTargets;
  setTargets: React.Dispatch<React.SetStateAction<TiVoTargets>>;
} | null>(null);

export function TargetsProvider({ children }: { children: React.ReactNode }) {
  const { tabId: platformId } = useParams();
  const [targets, setTargets] = useState<TiVoTargets>({
    platforms: [],
    oems: [],
    clientTypes: [],
  });

  useEffect(() => {
    // Set the default target based on the platform ID.
    if (platformId) {
      setTargets({
        platforms: [platformId],
        oems: [],
      });
    }
  }, [platformId]);

  return (
    <TargetsContext.Provider value={{ targets, setTargets }}>
      {children}
    </TargetsContext.Provider>
  );
}

export function useTargets() {
  const ctx = useContext(TargetsContext);
  if (!ctx) {
    throw new Error("useTargets must be used within TargetsProvider");
  }
  return ctx;
}
